// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetUserByIdRequestModel from '../../model/get-user-by-id-request-model';
import GetUserByIdRequestDTO from '../dto/get-user-by-id-request-dto';

export default abstract class GetUserByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetUserByIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  'id'?: number;

  static toModel(dto: DeepPartial<GetUserByIdRequestDTO>): GetUserByIdRequestModel;
  static toModel(dto: DeepPartial<GetUserByIdRequestDTO> | undefined | null): GetUserByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetUserByIdRequestDTO> | undefined | null): GetUserByIdRequestModel | undefined {
    return dto ? new GetUserByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetUserByIdRequestModel> | GetUserByIdRequestModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'id': unwrapped.id,
    } as GetUserByIdRequestDTO;
  }
}
